import { type ReactNode } from "react";
import { buttonClasses } from "../Button/Button";
import HintTrigger from "../HintTrigger/HintTrigger";

type BlockedActionProps = {
  label: string;
  reason: string;
  children: ReactNode;
  className?: string;
  /** Keeps only the caller's look, for icons and text links in place of a button */
  plain?: boolean;
};

// An action that cannot run. A disabled button receives no tap, so this one stays enabled, does
// nothing and explains why.
const BlockedAction = ({ label, reason, children, className = "", plain = false }: BlockedActionProps) => (
  <HintTrigger
    label={label}
    hint={reason}
    className={`${plain ? "cursor-not-allowed" : buttonClasses("blocked")} ${className}`}
    isDisabled
  >
    {children}
  </HintTrigger>
);

export default BlockedAction;
